import logApi from '../../services/logApi'

const SET_LOG = "SET_LOG"

const state = {
	log: null,
}

const mutations = {
	[SET_LOG](state, data) {
		state.log = data
	}
}

const actions = {
	async fetchLog({ getters }, data) {
		let token = getters.getAuthService.token
		return await logApi.fetchLog(token, data)
	}
}

const getters = {
	getLog: state => {
		return state.log
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}